import React, { useRef, useEffect, useState } from "react";
import Hls from "hls.js";
import { Maximize, Minimize } from "lucide-react";
import { getUserIp } from "../../../api/thirdparty";

const VideoPlayer = ({ videoUrl }) => {
    const videoRef = useRef(null);
    const containerRef = useRef(null);
    const [showButton, setShowButton] = useState(false);
    const [isFullscreen, setIsFullscreen] = useState(false);


    // Inside your component
    const [watermark4set, setWatermark4] = useState("");

    useEffect(() => {
        const fetchIp = async () => {
            try {
                const { data } = await getUserIp();
                setWatermark4(data.ip); // set IP as the 4th watermark
                console.log("ip check", data.ip);

            } catch (err) {
                console.error("Failed to get IP:", err);
                setWatermark4("IP not available");
            }
        };

        fetchIp();
    }, []);

    const watermark1 = localStorage.getItem("AffiliateName") || "";
    const watermark2 = localStorage.getItem("Mobile") || "";
    const watermark3 = localStorage.getItem("EmailID") || "";
    const watermark4 = watermark4set

    // Update watermark4 in watermarks when it’s fetched
    useEffect(() => {
        setWatermarks([
            { text: watermark1, top: "10%", left: "10%" },
            { text: watermark2, top: "30%", left: "20%" },
            { text: watermark3, top: "50%", left: "40%" },
            { text: watermark4set, top: "70%", left: "60%" }, // now uses latest IP
        ]);
    }, [watermark4set, watermark1, watermark2, watermark3]);


    // Now you can use all 4 watermarks:
    // Watermark positions
    const [watermarks, setWatermarks] = useState([
        { text: watermark1, top: "10%", left: "10%" },
        { text: watermark2, top: "30%", left: "20%" },
        { text: watermark3, top: "50%", left: "40%" },
        { text: watermark4, top: "70%", left: "60%" },
    ]);

    useEffect(() => {
        if (!videoRef.current) return;

        if (Hls.isSupported()) {
            const hls = new Hls({ enableWorker: true, lowLatencyMode: true });
            hls.loadSource(videoUrl);
            hls.attachMedia(videoRef.current);
            return () => hls.destroy();
        } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
            videoRef.current.src = videoUrl;
        }
    }, [videoUrl]);

    const handleFullscreen = () => {
        const el = containerRef.current;
        if (!document.fullscreenElement) {
            if (el.requestFullscreen) el.requestFullscreen();
            else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
            else if (el.msRequestFullscreen) el.msRequestFullscreen();
            setIsFullscreen(true);
        } else {
            if (document.exitFullscreen) document.exitFullscreen();
            else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
            else if (document.msExitFullscreen) document.msExitFullscreen();
            setIsFullscreen(false);
        }
    };

    useEffect(() => {
        const handleExit = () => setIsFullscreen(!!document.fullscreenElement);
        document.addEventListener("fullscreenchange", handleExit);
        return () => document.removeEventListener("fullscreenchange", handleExit);
    }, []);

    // ✅ Move watermarks randomly every 30 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setWatermarks((prev) =>
                prev.map((wm) => ({
                    ...wm,
                    top: `${Math.random() * 80 + 5}%`, // avoid edges
                    left: `${Math.random() * 80 + 5}%`,
                }))
            );
        }, 15000); // 30 seconds

        return () => clearInterval(interval);
    }, []);

    return (
        <div
            ref={containerRef}
            style={{
                position: "relative",
                width: "100%",
                maxWidth: "800px",
                margin: "auto",
                background: "black",
                overflow: "hidden",
            }}
            onMouseEnter={() => setShowButton(true)}
            onMouseLeave={() => setShowButton(false)}
        >
            <video
                ref={videoRef}
                width="100%"
                style={{ objectFit: "contain", display: "block" }}
                controls
                autoPlay
                muted
                playsInline
                controlsList="nodownload nofullscreen"
            >
                <source src={videoUrl} type="application/vnd.apple.mpegurl" />
                Your browser does not support HLS.
            </video>

            {/* 🔒 Watermarks */}
            {watermarks.map((wm, i) => (
                <div
                    key={i}
                    style={{
                        position: "absolute",
                        top: wm.top,
                        left: wm.left,
                        color: "red",
                        fontSize: "13px",
                        fontWeight: "400",
                        pointerEvents: "none",
                        zIndex: 9999,
                        transition: "top 1s ease, left 1s ease", // smooth jump
                        fontFamily: "sans-serif"
                    }}
                >
                    {wm.text}
                </div>
            ))}

            {/* ⬜ Fullscreen toggle button */}
            {showButton && (
                <button
                    onClick={handleFullscreen}
                    style={{
                        position: "absolute",
                        bottom: isFullscreen ? "40px" : "35px",
                        right: isFullscreen ? "90px" : "52px",
                        background: "rgba(0,0,0,0.5)",
                        color: "white",
                        border: "1px solid white",
                        borderRadius: "4px",
                        cursor: "pointer",
                        padding: "4px 8px",
                        zIndex: 9999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "all 0.3s ease",
                    }}
                >
                    {isFullscreen ? <Minimize size={18} /> : <Maximize size={18} />}
                </button>
            )}
        </div>
    );
};

export default VideoPlayer;
